<script lang="ts">
	import { reveal } from '$lib/actions/reveal';
	import { tilt } from '$lib/actions/tilt';
	import SectionHeading from '$lib/components/ui/SectionHeading.svelte';
	import { features } from '$lib/data/features';
	import { DotLottieSvelte } from '@lottiefiles/dotlottie-svelte';
</script>

<section class="mx-auto mt-20 max-w-[1216px] px-4 sm:mt-32 lg:mt-40 lg:px-0">
	<div class="reveal" use:reveal>
		<SectionHeading
			eyebrow="The platform"
			title="One platform. Every edge workload."
			description="Admiral is tightly coupled by design. We ship the kernel and orchestrator together, so embedded engineering becomes a one-person job."
		/>
	</div>
	<div class="stagger-children grid grid-cols-1 gap-4 md:grid-cols-3" use:reveal>
		{#each features as f}
			<div use:tilt class="enterprise-card shine rounded-xl p-8">
				<div
					class="border-blue/20 bg-blue/10 mb-6 flex h-14 w-14 items-center justify-center rounded-lg border"
				>
					{#if f.lottieSrc}
						<div style="width: 2.5rem; height: 2.5rem;">
							<DotLottieSvelte
								src={f.lottieSrc}
								backgroundColor="transparent"
								speed={1}
								loop
								autoplay
							/>
						</div>
					{:else if f.svgPath}
						<svg
							class="text-blue-soft h-6 w-6"
							fill="none"
							stroke="currentColor"
							viewBox="0 0 24 24"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="1.5"
								d={f.svgPath}
							/>
						</svg>
					{:else}
						<div class="h-10 w-10"></div>
					{/if}
				</div>
				<h3 class="mb-3 font-display text-xl font-medium tracking-tight text-white">
					{f.title}
				</h3>
				<p class="font-display text-base leading-relaxed text-white/60">
					{f.description}
				</p>
			</div>
		{/each}
	</div>
</section>
